module.exports = __webpack_public_path__ + "static/img/闪钥.f9a3761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/product-article/闪钥.png
// module id = 659
// module chunks = 1